import { cx } from "@jugl-web/utils";
import { FC, ReactNode } from "react";

export type InlineAlertVariant = "info" | "warning";

export interface InlineAlertProps {
  variant: InlineAlertVariant;
  children: ReactNode;
  className?: string;
}

const containerClassesByVariant: Record<InlineAlertVariant, string> = {
  info: "border-l-messages-chatBubbleSender bg-[#F0F8FF]",
  warning: "border-l-gradients-g4 bg-grey-100",
};

/**
 * InlineAlert is a reusable component for displaying inline alert messages.
 * It supports multiple variants (info, warning) and can be extended (e.g. for size adjustments) with custom `className`.
 */
export const InlineAlert: FC<InlineAlertProps> = ({
  variant,
  children,
  className,
}) => (
  <div
    className={cx(
      "flex items-center gap-2 rounded-xl border-l-4 border-t-0 border-b-0 border-r-0 border-solid py-3 px-6",
      "font-secondary text-dark-800 text-sm font-normal leading-[140%]",
      containerClassesByVariant[variant],
      className
    )}
  >
    {children}
  </div>
);
